
<template>
<div class="loginBox">
    <div class="center">
        <div class="right">
            <img src="../assets/zi.png" alt="">
            <div class="loginBox22" @keyup.enter="login">
                <div>
                    <p>用户登录</p>
                    <input class="user" v-model="formData.username" type="text" placeholder="请输入用户名">
                    <input class="pwd" v-model="formData.password" type="password" placeholder="请输入密码">
                    <div class="code">
                        <input type="text" v-model="formData.yzm" placeholder="请输入验证码" maxlength="4">
                        <img :src="captchaSrc" @click="flushCaptcha" />
                    </div>
                    <el-button type="primary" round @click="login">登录</el-button>
                </div>
            </div>
        </div>
    </div>
    <!-- <p style="position:fixed;bottom:20px;left:50%;transform:translate(-50%, 0);color:#ddd">技术支持&copy;衡水云翼信息技术有限公司</p> -->
</div>
</template>
<script>
import axios from 'axios';
axios.defaults.withCredentials = true; //设置cross跨域 并设置访问权限 允许跨域携带cookie信息
export default {
    data: function() {
        return {
            captcha: this.domain + '/captcha',
            captchaSrc: '',
            formData: {},
        }
    },
    mounted: function() {
        this.init();
    },
    methods: {
        init: function() {
            this.flushCaptcha();
        },

        flushCaptcha: function() {
            this.captchaSrc = this.captcha + '?' + Math.random()
            this.formData.yzm = ''
        },

        login: function() {
            var that = this
            if (!this.formData.username) {
                this.$message.error('请输入用户名！');
                return false;
            }
            if (!this.formData.password) {
                this.$message.error('请输入密码！');
                return false;
            }
            if (!this.formData.yzm) {
                this.$message.error('请输入验证码！');
                return false;
            }
            var pwd = this.$md5(this.formData.password)
            axios.post(this.domain + '/login/pc', {
                password:pwd,
                username:this.formData.username,
                yzm:this.formData.yzm
            }).then(res => {
                if (res.data.code == 200) {
                    this.getArea()
                    setTimeout(function(){
                        that.$router.push('/mail')
                    },500)
                    
                } else {
                    this.$message.error(res.data.msg);
                    this.flushCaptcha();
                }
            }).catch(function(error) { // 请求失败处理
                console.log(error);
            });
        },
        getArea:function(){
            this.http.post('/areas/selectAddress').then(res=>{
                localStorage.setItem('area',JSON.stringify(res))
            })
        },
    }
}
</script>
<style lang="less" scoped>


</style>
